import {Observable, Subject} from 'rxjs';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import {UsuariosService} from '../../core/services/usuarios.service';
import {AtualizacaoService} from 'src/app/content/pages/services/atualizacao.service';
import {
  ParamEspecificoLocalStorageService
} from '../../content/pages/components/roteirizacao/services/param-especifico-local-storage.service';
import {MensagensService} from 'max-ng-lib';
import {isNullOrUndefined} from 'util';
import {ParametrosOcultoEnum, ParametrosPortalEnum} from 'src/app/content/pages/enums/parametros.enum';
import {SemPararPedagioService} from '../../content/pages/services/sem-parar-pedagio.service';

@Injectable()
export class AuthGuard implements CanActivate {

  token: any;

  constructor(
    public mensagemService: MensagensService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private usuarioService: UsuariosService,
    private atualizacao: AtualizacaoService,
    private paramEspecificoLocalStorageService: ParamEspecificoLocalStorageService,
    private semPararService: SemPararPedagioService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

    const return$ = new Subject<boolean>();
    const tokenQueryParam = route.queryParams.PWE;
    if (tokenQueryParam) {
      this.authenticationService.limparSessao();

      this.authenticationService.salvarToken(tokenQueryParam);
      this.authenticationService.salvarUsuarioAutenticado('S');
      this.atualizacao.processar().subscribe(res => console.log(res));
      this.semPararService.atualizarPracasPedagioPorIntegracao().subscribe(res => console.log(res));
      this.carregarParametrosIniciais();


      this.paramEspecificoLocalStorageService
        .salvarListaParametroLocalStorage(
          [
            'VISUALIZAR_SOMENTE_OBSENTREGA',
            'EXIBIR_SEQ_PEDIDO',
            'VISUALIZAR_SEQ_PREVISTA_CARGA_ROTEIRIZADA',
            'EXIBIR_CABECA_CEP_PIN',
            'TAMANHO_CAMPO_DESTINO_CAR',
            'PERMITIR_USABILIDADE_PRE_CARGA_ROTEIRZADA'
          ]).then(() => {
      });

      setTimeout(() => {
        this.usuarioService.getUserToken()
          .subscribe(
            (userToken) => {
              this.authenticationService.salvarUsuarioLogado(userToken);
              this.redirecioneParaPaineis(return$);
            }, (error) => {
              if (error.status === 401) {
                this.redirecionePara401(return$);
              } else {
                this.redirecioneParaLogin(return$);
              }

            });
      }, 1000);
    } else {
      setTimeout(() => this.redirecioneParaLogin(return$), 100);
    }

    return return$;
  }

  carregarParametrosIniciais() {

    const parametros = [
      ParametrosPortalEnum.VISUALIZAR_SOMENTE_OBSENTREGA,
      ParametrosPortalEnum.EXIBIR_SEQ_PEDIDO,
      ParametrosPortalEnum.VISUALIZAR_SEQ_PREVISTA_CARGA_ROTEIRIZADA,
      ParametrosPortalEnum.TAMANHO_CAMPO_DESTINO_CAR,
      ParametrosPortalEnum.EXIBIR_CABECA_CEP_PIN,
      ParametrosPortalEnum.GERAR_CARGA_REENTREGAS,
      ParametrosPortalEnum.PERMITIR_USABILIDADE_PRE_CARGA_ROTEIRZADA,
      ParametrosOcultoEnum.EXIBIR_TOTALIZADOR_QUANTIDADE_UNIDADES
    ];

    for (const parametro of parametros) {
      this.paramEspecificoLocalStorageService.salvarParametroEspecificoLocalStorage(parametro).then(() => {});
    }
  }


  redirecioneParaPaineis(return$: Subject<boolean>) {
    return$.next(true);
    this.router.navigate(['/pages']);
    // setTimeout(() => {
    //   this.abrirPesquisasDepoisMelhorias();
    // }, 2000);
  }

  redirecioneParaLogin(return$: Subject<boolean>) {
    return$.next(false);
    this.limparSessao();
    this.router.navigate(['/login']);
  }

  redirecionePara401(return$: Subject<boolean>) {
    this.limparSessao();
    this.router.navigate(['/login/401']);
  }

  private limparSessao() {
    this.authenticationService.limparSessao();
  }
}
